import styled from 'styled-components';
export var StyledTableBody = /*#__PURE__*/styled.tbody.withConfig({
  displayName: "StyledTableBody",
  componentId: "c11n-8-107-0__sc-f04mzl-0"
})([""]);